import React, { ReactElement } from 'react';

export default function vehicleIcon(): ReactElement | null {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="172"
      height="94"
      fill="none"
      viewBox="0 0 172 94"
    >
      <path
        fill="#FBDFCB"
        stroke="#FBDFCB"
        strokeWidth="2"
        d="M53.271 81.01H21.616c-8.98 0-19.843-7.868-19.843-15.26 0-7.39 2.297-11.004 9.855-11.004s6.363 14.625 11.089 14.625 7.873 1.936 9.289 3.356c1.416 1.42 2.996 5.45 9.61 6.078A63.333 63.333 0 0153.27 81.01z"
      ></path>
      <path
        fill="#FBDFCB"
        d="M24.448 50.259c1.359 0 2.46-1.1 2.46-2.458a2.459 2.459 0 00-2.46-2.457c-1.36 0-2.46 1.1-2.46 2.457a2.459 2.459 0 002.46 2.458zM26.613 65.034a1.717 1.717 0 10-1.718-1.715c0 .947.769 1.715 1.718 1.715zM35.304 59.648a1.044 1.044 0 10.001-2.088 1.044 1.044 0 00-.001 2.088z"
      ></path>
      <path
        fill="#FCF4ED"
        d="M108.451.231H81.295c-17.378 0-31.466 14.07-31.466 31.424v30.696c0 17.355 14.088 31.424 31.466 31.424h27.156c17.378 0 31.466-14.069 31.466-31.424V31.655c0-17.355-14.088-31.424-31.466-31.424z"
      ></path>
      <path
        fill="#FBDFCB"
        d="M43.151 71.753h107.226a3.148 3.148 0 003.146-2.797l2.518-21.928c.048-.424.01-.854-.113-1.263a3.155 3.155 0 00-1.6-1.902 3.147 3.147 0 00-1.226-.329l-28.163-1.647-12.914-19.483a3.141 3.141 0 00-2.75-1.401l-41.145 1.69a3.149 3.149 0 00-2.87 2.175l-6.18 19.144-17.2 1.458a3.14 3.14 0 00-2.876 3.293l1.039 20.03a3.14 3.14 0 003.108 2.96z"
      ></path>
      <path
        fill="#FBD2B5"
        d="M130.5 71.5H152s0-6-6-6H48c-7.193-.682-4-9.5-8.5-10.5 0 5.5-1 16.5 3 16.5h88z"
      ></path>
      <path
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M43.12 71.734h107.225a3.149 3.149 0 003.147-2.797l2.517-21.928a3.136 3.136 0 00-1.713-3.165 3.149 3.149 0 00-1.226-.33l-28.162-1.646-12.914-19.483a3.15 3.15 0 00-2.75-1.401l-41.146 1.69a3.15 3.15 0 00-2.87 2.175l-6.18 19.144-17.2 1.458a3.148 3.148 0 00-2.875 3.293l1.038 20.03a3.14 3.14 0 003.109 2.96v0z"
      ></path>
      <path
        fill="#FBDFCB"
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M60.213 80.81c5.682 0 10.29-4.601 10.29-10.276s-4.608-10.276-10.29-10.276c-5.683 0-10.29 4.6-10.29 10.276 0 5.675 4.607 10.276 10.29 10.276z"
      ></path>
      <path
        stroke="#FF8000"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M147.507 10.375a3.874 3.874 0 003.876-3.872 3.874 3.874 0 00-3.876-3.871 3.874 3.874 0 00-3.877 3.871 3.874 3.874 0 003.877 3.872z"
      ></path>
      <path
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M125.675 19.554a2.604 2.604 0 002.606-2.602 2.604 2.604 0 00-2.606-2.602 2.604 2.604 0 00-2.605 2.602 2.604 2.604 0 002.605 2.602z"
      ></path>
      <path
        fill="#FBDFCB"
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M134.687 80.81c5.683 0 10.29-4.601 10.29-10.276s-4.607-10.276-10.29-10.276c-5.682 0-10.289 4.6-10.289 10.276 0 5.675 4.607 10.276 10.289 10.276z"
      ></path>
      <path
        fill="#FBD2B5"
        d="M55.48 79.29c5.92 3.312 10.92-.957 12.2-1.769 0 0-7.004.092-10.248-1.722C54.19 73.984 50.662 68 50.662 68c-1.22 2.182-1.103 7.977 4.817 11.29zM129.479 79.29c5.921 3.312 10.921-.957 12.201-1.769 0 0-7.004.092-10.248-1.722-3.243-1.815-6.77-7.799-6.77-7.799-1.221 2.182-1.103 7.977 4.817 11.29z"
      ></path>
      <path
        stroke="#FBDFCB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M23 81h148"
      ></path>
      <path
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M60.213 80.81c5.682 0 10.29-4.601 10.29-10.276 0-5.676-4.608-10.276-10.29-10.276-5.683 0-10.29 4.6-10.29 10.276 0 5.675 4.607 10.275 10.29 10.275zM134.687 80.81c5.683 0 10.29-4.601 10.29-10.276 0-5.676-4.607-10.276-10.29-10.276-5.682 0-10.289 4.6-10.289 10.276 0 5.675 4.607 10.275 10.289 10.275z"
      ></path>
      <path
        fill="#FF8000"
        d="M60.212 75.16a4.629 4.629 0 004.632-4.626 4.629 4.629 0 00-4.632-4.626 4.629 4.629 0 00-4.631 4.626 4.629 4.629 0 004.631 4.625zM134.688 75.16a4.628 4.628 0 004.631-4.626 4.628 4.628 0 00-4.631-4.626 4.628 4.628 0 00-4.632 4.626 4.628 4.628 0 004.632 4.625z"
      ></path>
      <path
        fill="#fff"
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M39.388 57.348h5.664a1.26 1.26 0 001.259-1.257V52.95a1.256 1.256 0 00-1.26-1.257H39.08l.308 5.656zM154.788 57.348h-6.023a1.256 1.256 0 01-1.258-1.257v-5.028a1.256 1.256 0 011.258-1.257h6.885l-.862 7.542zM125 41.933h-10a1.26 1.26 0 01-1.164-.766l-4.736-11.42A1.257 1.257 0 01110.258 28h5.263L125 41.933zM89.43 28h13.802a1.263 1.263 0 011.164.773l4.878 11.627a1.26 1.26 0 01-.114 1.18 1.256 1.256 0 01-1.044.561H89.431V28zM85.504 28H72.288a1.26 1.26 0 00-1.215.943L68.04 40.57a1.255 1.255 0 001.22 1.571h16.244V28z"
      ></path>
      <path
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M153 62L156 62"
      ></path>
      <path
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M38 62L41 62"
      ></path>
      <path
        fill="#F7F7F7"
        d="M113.351 42H122c0-5-7.027-7-10-7 .541 3 1.351 7 1.351 7zM68 42h16c0-5-9-7-14.5-7-.5 3-1.5 7-1.5 7zM90 42h16c0-5-10.5-7-16-7v7z"
      ></path>
      <path
        stroke="#FF8000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M125 41.933h-10a1.26 1.26 0 01-1.164-.766l-4.736-11.42A1.257 1.257 0 01110.258 28h5.263L125 41.933zM85.504 28H72.288a1.26 1.26 0 00-1.215.943L68.04 40.57a1.255 1.255 0 001.22 1.571h16.244V28zM89.43 28h13.802a1.263 1.263 0 011.164.773l4.878 11.627a1.26 1.26 0 01-.114 1.18 1.256 1.256 0 01-1.044.561H89.431V28z"
      ></path>
    </svg>
  );
}
